<ng-container *ngIf="supportSrcSet; else imageWithoutSrcSet">
  <img draggable="false"
    [loading]="(isLcpElement$ | async) ? 'eager' : 'lazy'"
    [attr.fetchpriority]="(isLcpElement$ | async) ? 'high' : 'auto'"
    [ngStyle]="ngStyle"
    [alt]="'alt_' + type"
    [src]="srcImage"
    [srcset]="srcSet"
    (error)="errorHandler()"
    (click)="clickImage.emit()" />
</ng-container>
<ng-template #imageWithoutSrcSet>
  <img draggable="false"
    [loading]="(isLcpElement$ | async) ? 'eager' : 'lazy'"
    [attr.fetchpriority]="(isLcpElement$ | async) ? 'high' : 'auto'"
    [ngStyle]="ngStyle"
    [src]="srcImage"
    [alt]="'alt_' + type"
    (error)="errorHandler()"
    (click)="clickImage.emit()" />
</ng-template>